import { TabGroupInterface } from '../../../Interfaces/TabInterface'
import Tab from './Tab'
import { useState } from 'react'

const TabGroup = (props: TabGroupInterface) => {
  const [currentChild, setCurrentChild] = useState<number>(
    props.items!.findIndex((n) => n.index)
  )
  const element = props.items![currentChild].element

  return (
    <>
      <div
        className={`${props.className} bg-primary flex justify-center items-center gap-8 w-full `}
      >
        {props.items?.map((n, i) => (
          <Tab
            className={n.className}
            title={n.title}
            icon={n.icon}
            index={currentChild === i}
            key={i}
            keyItem={i}
            onClick={setCurrentChild}
          />
        ))}
      </div>
      {element}
    </>
  )
}

export default TabGroup
